import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StepsComponent } from './steps.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: StepsComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class StepsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/steps/steps-routing.module.ts